
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.027 2.411H13.702V0L0 2.243v17.949l13.702 2.244v-2.923h10.325c.539 0 .973-.405.973-.907V3.318c0-.503-.434-.907-.973-.907zM7.061 12.44H5.95v2.668l-1.425-.084V7.506l2.637-.144c.854-.028 1.252.258 1.646.814.191.27.308.607.364.958v1.07c-.185 1.19-.968 2.178-2.112 2.235zm17.136 6.25l-10.495.013v-1.858h7.53v-1.023h-7.53v-1.388h7.53V13.41h-7.53v-2.558a3.36 3.36 0 002.591 1.21c1.85 0 3.35-1.48 3.35-3.305h-3.35V5.453a3.36 3.36 0 00-2.59 1.21V3.215h10.494V18.69z","fill":"#fff"}}),_c('path',{attrs:{"d":"M16.77 5.038v3.306h3.35c0-1.826-1.5-3.306-3.35-3.306zM6.732 8.781l-.782.005v2.265h.74c.531-.023.93-.594.904-1.187-.023-.669-.38-1.066-.862-1.083z","fill":"#fff"}})])
          )
        }
      }
    